import { Expose, Transform, Type } from "class-transformer";
import { parseAppDate } from "@/utils/dates/dateFormats";
import { parseOptionalInteger, toCents } from "@/utils/numberUtils";
import { InvoiceDocumentTypeEnum } from "@altertec_gparn/lib";
import { SaveInvoiceLineDto } from "./save-invoice-line.dto";

function toOptionalCents(value: unknown): number | undefined {
  if (value == null || value === "") {
    return undefined;
  }

  return toCents(Number(value));
}

export class UpdateInvoiceDto {
  @Expose()
  numeration: string;

  @Expose()
  deliveryNumeration: string;

  @Transform(({ value }) => parseAppDate(value, false))
  @Expose()
  date?: Date;

  @Transform(({ value }) => parseAppDate(value, false))
  @Expose()
  creationDate: Date;

  @Expose()
  @Transform(({ value }) => toOptionalCents(value))
  amount?: number;

  @Expose()
  @Transform(({ value }) => toCents(value))
  totalAmount: number;

  @Expose()
  @Transform(({ value }) => parseOptionalInteger(value))
  vatType?: number;

  @Expose()
  @Transform(({ value }) => toCents(value))
  vatAmount?: number;

  @Expose()
  @Transform(({ value }) => parseOptionalInteger(value))
  withholdingType?: number;

  @Expose()
  @Transform(({ value }) => toCents(value))
  withholdingAmount?: number;

  @Transform(({ value }) => parseAppDate(value, false))
  @Expose()
  dueDate?: Date;

  @Transform(({ value }) => parseAppDate(value, false))
  @Expose()
  paymentDate?: Date;

  @Expose()
  deliveredTo?: string | null;

  @Expose()
  orderCode?: string;

  @Expose()
  accountingComment?: string | null;

  @Expose()
  operativeUnitId: string;

  @Expose()
  clientId?: string;

  @Expose()
  companyId?: string;

  @Expose()
  bankId?: string;

  @Expose()
  canBeAdvanced?: boolean;

  @Expose()
  referencedInvoiceId?: string | null;

  @Expose()
  type?: InvoiceDocumentTypeEnum;

  @Expose()
  @Type(() => SaveInvoiceLineDto)
  lines?: SaveInvoiceLineDto[];
}
